import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lifedi-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  locationUrl: string = window.location.origin;

  constructor() { }

  ngOnInit(): void {
  }

}
